import React, { useCallback, useEffect, useState } from 'react'
import { adminAddConfiguration, adminGetConfigurations } from '../services/Api';
import { toast, ToastContainer } from 'react-toastify';
import { Radio } from 'antd';

const ConfigurationManagement = () => {
    const token = localStorage.getItem('token');
    const [autoCancelTime, setAutoCancelTime] = useState(0);
    const [unavailabilityCharge, setUnavailabilityCharge] = useState(0)
    const [cancelationCharge, setCancelationCharge] = useState(0)
    const [referrerCount, setReferrerCount] = useState(0)
    const [viewSlider, setViewSlider] = useState(false)
    const [showAlert, setShowAlert] = useState(false)
    const [alertMessage, setAlertMessage] = useState('')
    const [alertMessageSpeed, setAlertMessageSpeed] = useState('')
    const getAllConfigurations = useCallback(() => {
        // setIsLoading(true);
        adminGetConfigurations()
            .then((res) => {
                setAutoCancelTime(res?.data?.data?.auto_cancel_timing)
                setUnavailabilityCharge(res?.data?.data?.no_show_deduction)
                setCancelationCharge(res?.data?.data?.after_driver_assignment)
                setReferrerCount(res?.data?.data?.referral_count)
                setViewSlider(res?.data?.data?.show_slider)
                setShowAlert(res?.data?.data?.show_alert)
                setAlertMessage(res?.data?.data?.alert_message)
                setAlertMessageSpeed(res?.data?.data?.alert_message_speed)
            })
            .catch(() => {
                // setIsLoading(false);
            });
    }, [])

    useEffect(() => {
        getAllConfigurations()
    }, [token, getAllConfigurations])

    const handleAddConfiguration = () => {
        adminAddConfiguration(autoCancelTime, unavailabilityCharge, cancelationCharge, referrerCount, viewSlider, showAlert, alertMessage, alertMessageSpeed)
            .then((res) => {
                console.log(res)
                setCancelationCharge('')
                setUnavailabilityCharge('')
                setAutoCancelTime('')
                setReferrerCount('')
                setViewSlider('')
                setAlertMessageSpeed('')
                getAllConfigurations()
                toast(res?.data?.message)
            })
            .catch((err) => {
                toast(err.response.data.message)
            })
    }


    return (
        <>
            <ToastContainer />
            <div className=" space-y-6 px-5 py-5">
                <div className="block sm:flex justify-between">
                    <p className="text-base md:text-xl lg:text-2xl text-[#3A4352] font-semibold"> Our Configuration</p>
                </div>
                <div className='border-2 border-gray-400 rounded-md p-5'>
                    {/* {deductionData !== null && Object.keys(deductionData).length > 0 ?
                            <div>
                                <div className=' flex flex-col'>
                                    <label className=' text-gray-400'>Auto Cancel Time</label>
                                    <input className='[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none outline-none ms-5 mt-3 border border-gray-400 h-8 ps-2 rounded-md w-1/2' placeholder='Please Enter Deduction %' type='number' min={1} max={99} onChange={(e) => setAutoCancelTime(e.target.value)} value={autoCancelTime} />
                                </div>
                                <div className=' flex flex-col'>
                                    <label className=' text-gray-400'>Unavailability Charge</label>
                                    <input className='[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none outline-none ms-5 mt-3 border border-gray-400 h-8 ps-2 rounded-md w-1/2' placeholder='Please Enter Deduction %' type='number' min={1} max={99} onChange={(e) => setUnavailabilityCharge(e.target.value)} value={unavailabilityCharge} />
                                </div>
                                <div className=' flex flex-col'>
                                    <label className=' text-gray-400'>Cancel Cancelation</label>
                                    <input className='[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none outline-none ms-5 mt-3 border border-gray-400 h-8 ps-2 rounded-md w-1/2' placeholder='Please Enter Deduction %' type='number' min={1} max={99} onChange={(e) => setCancelationCharge(e.target.value)} value={cancelationCharge} />
                                </div>
                                <div className=' flex justify-end'>
                                    <button className='bg-[#008400] text-white px-5 py-2 rounded-md active:scale-95 duration-500' onClick={handleAddConfiguration}> Update </button>
                                </div>
                            </div>
                            : */}
                    <div>
                        <div className='grid grid-cols-1 sm:grid-cols-2 gap-3'>
                            <div className=' flex flex-col'>
                                <label className=' text-gray-400 text-sm font-medium'>Auto Cancel Time</label>
                                <input className='[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none outline-none ms-2 mt-1 border border-gray-400 h-8 ps-2 rounded-md w-[80%] placeholder:text-sm' placeholder='Time (in Min.)' type='number' min={1} max={99} onChange={(e) => setAutoCancelTime(e.target.value)} value={autoCancelTime} />
                            </div>
                            <div className=' flex flex-col'>
                                <label className=' text-gray-400 text-sm font-medium'>Unavailability Charge</label>
                                <input className='[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none outline-none ms-2 mt-1 border border-gray-400 h-8 ps-2 rounded-md w-[80%] placeholder:text-sm' placeholder='Charge %' type='number' min={1} max={99} onChange={(e) => setUnavailabilityCharge(e.target.value)} value={unavailabilityCharge} />
                            </div>
                            <div className=' flex flex-col'>
                                <label className=' text-gray-400 text-sm font-medium'>Cancelation Charge</label>
                                <input className='[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none outline-none ms-2 mt-1 border border-gray-400 h-8 ps-2 rounded-md w-[80%] placeholder:text-sm' placeholder='Charge %' type='number' min={1} max={99} onChange={(e) => setCancelationCharge(e.target.value)} value={cancelationCharge} />
                            </div>
                            <div className=' flex flex-col'>
                                <label className=' text-gray-400 text-sm font-medium'>Referrer Count</label>
                                <input className='[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none outline-none ms-2 mt-1 border border-gray-400 h-8 ps-2 rounded-md w-[80%] placeholder:text-sm' placeholder='Charge %' type='number' min={1} max={99} onChange={(e) => setReferrerCount(e.target.value)} value={referrerCount} />
                            </div>
                            <div className=' flex flex-col'>
                                <label className=' text-gray-400 text-sm font-medium'>View Slider</label>
                                <Radio.Group group="view_slider" value={viewSlider} onChange={(e) => setViewSlider(e.target.value)} className='flex items-center gap-2 ms-2 mt-1'>
                                    <Radio value={true}>Yes</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                                {/* <input className='[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none outline-none ms-2 mt-1 border border-gray-400 h-8 ps-2 rounded-md w-[80%] placeholder:text-sm' placeholder='Charge %' type='number' min={1} max={99} onChange={(e) => setReferrerCount(e.target.value)} value={referrerCount} /> */}
                            </div>
                            <div className=' flex flex-col'>
                                <label className=' text-gray-400 text-sm font-medium'>Show Alert</label>
                                <Radio.Group group="show_alert" value={showAlert} onChange={(e) => setShowAlert(e.target.value)} className='flex items-center gap-2 ms-2 mt-1'>
                                    <Radio value={true}>Yes</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                                {/* <input className='[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none outline-none ms-2 mt-1 border border-gray-400 h-8 ps-2 rounded-md w-[80%] placeholder:text-sm' placeholder='Charge %' type='number' min={1} max={99} onChange={(e) => setReferrerCount(e.target.value)} value={referrerCount} /> */}
                            </div>
                            <div className=' flex flex-col'>
                                <label className=' text-gray-400 text-sm font-medium'>Alert Message</label>
                                <input className='[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none outline-none ms-2 mt-1 border border-gray-400 h-16 ps-2 rounded-md w-[80%] placeholder:text-sm' placeholder='Alert Message' type='text' onChange={(e) => setAlertMessage(e.target.value)} value={alertMessage} />
                            </div>
                            <div className=' flex flex-col'>
                                <label className=' text-gray-400 text-sm font-medium'>Alert Message Speed (lower = faster)</label>
                                <input className='[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none outline-none ms-2 mt-1 border border-gray-400 h-8 ps-2 rounded-md w-[80%] placeholder:text-sm' placeholder='Alert Message Speed (lower = faster)' type='number' onChange={(e) => setAlertMessageSpeed(e.target.value)} value={alertMessageSpeed} />
                            </div>
                        </div>
                        <div className=' flex justify-end mt-2'>
                            <button className='bg-[#008400] text-white px-5 py-2 rounded-md active:scale-95 duration-500' onClick={handleAddConfiguration}> Save </button>
                        </div>
                    </div>
                    {/* } */}
                </div>
            </div>
        </>
    )
}

export default ConfigurationManagement
